export enum FetchState {
  pending = 'pending',
  fulfilled = 'fulfilled',
  rejected = 'rejected',
  initial = 'initial',
}

export type ButtonVariant = 'primaryGreen' | 'primaryRed'

export enum EAlertVariants {
  solid = 'solid',
  banner = 'banner',
  default = 'default',
}

export enum EHeaderVariants {
  mainHeader = 'mainHeader',
  bannerHeader = 'bannerHeader',
  subHeader = 'subHeader',
  articleTitle = 'articleTitle',
  subHeaderLarge = 'subHeaderLarge',
  forStickersStockCard = 'forStickersStockCard',
  glassesInfoPageGlassCard = 'glassesInfoPageGlassCard',
  subHeaderHaiti = 'subHeaderHaiti',
}

export enum EOperationSystem {
  windowsPhone = 'Windows Phone',
  android = 'Android',
  iOS = 'iOS',
  unknown = 'unknown',
}

export enum EModalVariants {
  standard = 'standard',
}

export enum ETabsVariants {
  standard = 'standard',
}

export enum EProgressVariants {
  standard = 'standard',
  standardGreen = 'standardGreen',
}

export enum ETextarea {
  standard = 'standard',
  mysteryShopperTextArea = 'mysteryShopperTextArea',
}

export enum EStockVariants {
  game = 'game',
}

export enum ECurrency {
  points = 3, // баллы
  stickers = 6, // наклейки
}

export enum ETagVariants {
  standard = 'default',
  primary = 'primary',
}

// existing profiles in Ngenix service https://my.ngenix.net/requests_processing/imo/8138876
// added manualy by ngenix admin
export enum NgenixProfile {
  '80x80' = '80x80',
}

export enum PermissionState {
  ERROR = 'error',
  DENIED = 'denied',
  PROMPT = 'prompt',
  GRANTED = 'granted',
}

export enum EsumErrorStatus {
  forbidden = 'forbidden',
  noCard = 'no_card',
  noAuth = 'no_auth',
}
